import React, { FC } from 'react'
import { Flex, Text } from '@moonpig/launchpad-components'
import { IconSystemCards, IconSystemReminder } from '@moonpig/launchpad-assets'
import { spacingPx, theme } from '@moonpig/launchpad-theme'
import { useProductsLocaleText } from '../../locale'
import type { ProductInfoProduct } from '../../types'
import { isDigitalGiftCard } from '../../utils/isDigitalGift/isDigitalGift'

const ICON_SPACING = spacingPx(3)({ theme })

type Props = {
  product: ProductInfoProduct
}

export const SellingPointsContent: FC<Props> = ({ product }) => {
  const localiseText = useProductsLocaleText()
  const isGiftCard = isDigitalGiftCard(product.category.department)

  return (
    <Flex
      data-testid="module-selling-points"
      bgcolor={'colorBackground06'}
      width={1}
      justifyContent="left"
      flexWrap="wrap"
      padding={5}
      mb={6}
      gap={spacingPx(5)({ theme })}
      borderRadius={{ xs: 0, md: 1 }}
    >
      <Flex gap={ICON_SPACING} alignItems="center">
        <IconSystemCards width="24px" />
        <Text>{localiseText('selling_points.printed_inside_card')}</Text>
      </Flex>
      {!isGiftCard && (
        <Flex gap={ICON_SPACING} alignItems="center">
          <IconSystemReminder width="24px" />
          <Text>
            {localiseText('selling_points.immediate_delivery_with_ecard')}
          </Text>
        </Flex>
      )}
    </Flex>
  )
}
